import React, { useEffect, useState } from 'react';
import { Alert, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ChannelYouTubeService from '../services/ChannelYouTubeService';

export default function ChannelYouTubeEligibilityNotice({ channel, kind }) {
  const [result, setResult] = useState(null);
  const channelId = channel?.id;

  useEffect(() => {
    if (!channelId) return undefined;
    let active = true;
    ChannelYouTubeService.get(kind, channelId, { refresh: true })
      .then((connection) => {
        if (active) setResult({ channelId, kind, connection });
      })
      .catch(() => {
        if (active) setResult({ channelId, kind, error: true });
      });
    return () => { active = false; };
  }, [channelId, kind]);

  if (!channelId || result?.channelId !== channelId || result.kind !== kind)
    return null;
  const reason = result.error
    ? 'Could not verify YouTube feature eligibility. Check the channel connection before uploading.'
    : result.connection.connected && result.connection.uploadBlockedReason;
  if (!reason) return null;

  return (
    <Alert
      severity="warning"
      sx={{ my: 2 }}
      action={
        <Button
          color="inherit"
          size="small"
          component={RouterLink}
          to={`/channels/${kind}?channelId=${encodeURIComponent(channelId)}`}
        >
          Configure channel
        </Button>
      }
    >
      {reason}
    </Alert>
  );
}
